// extracted by mini-css-extract-plugin
export var height = "FullWidthHeroMedia-module--height--c2363";
export var heroGradient = "FullWidthHeroMedia-module--heroGradient--c0c32";